import { render } from "./VtoLookSelection.vue?vue&type=template&id=0a72e6ca"
import script from "./VtoLookSelection.vue?vue&type=script&lang=js"
export * from "./VtoLookSelection.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__